// Gatsby requirements
import React from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './ContentCards.module.scss'


const ContentCards = ({ data }) => {

    return (
        <section
            className={`
                ${CSS.section}
                ${'section' + data._uid}
                ${data?.style === '2 cards per row, left aligned text' ? CSS.leftAligned : ''}
                ${data?.style === '3 cards per row, left aligned text' ? CSS.leftAlignedCards3 : ''}
                ${data?.style === '3 cards per row, centered text' ? CSS.cards3 : ''}
                ${data?.style === '3 cards per row, centered text, transparent cards' ? `${CSS.cards3} ${CSS.cardsTransparent}` : ''}
            `}
            style={{backgroundColor: data?.backgroundColor}}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid).replaceAll('.top-text', '.top-text' + data._uid).replaceAll('.card', '.card' + data._uid)
                }} />
            }

            <div className={CSS.wrapper}>
                {data?.richText &&
                    <div className={`${CSS.richtext} ${'top-text' + data._uid}`}>
                        <RichText content={data?.richText} />
                    </div>
                }

                <div className={CSS.cards}>
                    {data?.cards.map((loop, i) => (
                        <div key={i} className={`${CSS.card} ${'card' + data._uid}`}>
                            <img className={CSS.icon} loading="lazy" src={loop?.icon?.file?.url} alt={loop?.icon?.description} />
                            {loop?.largeTitle && <p className={CSS.largeTitle}>{loop?.largeTitle}</p>}
                            <RichText content={loop?.richText} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default ContentCards